import { render } from "./NewUser.vue?vue&type=template&id=f82f6478&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=f82f6478&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f82f6478"]])

export default __exports__